import React, { Suspense, memo } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import supportsHistory from '@meta-awesome/functions/src/supportsHistory'

import isNil from 'lodash/isNil'

import { selectAccessType, selectAuthenticated, selectUser } from '@galo-monitor/stores/authentication/selectorAuthentication'
import { AVAILABLE_CONTEXTS } from '@galo-monitor/stores/context'
import { selectCurrentContext } from '@galo-monitor/stores/context/selectorContext'
import { selectInFarmContext } from '@galo-monitor/stores/farm/selectorFarm'
import { selectCurrentProperty } from '@galo-monitor/stores/property/selectorProperty'
import CircularLoader from '@galo-monitor/web-components/Loader/CircularLoader'
import AuthenticatedScreenRouter from '@galo-monitor/web-containers/screens/authenticated/AuthenticatedScreenRouter'
import SelectPropertiesScreen from '@galo-monitor/web-containers/screens/authenticated/farm/SelectPropertiesScreen'
import GuestScreenRouter from '@galo-monitor/web-containers/screens/guest/GuestScreenRouter'

const forceRefresh = !supportsHistory()

const ScreenRouter = () => {
  const authenticated = useSelector(selectAuthenticated)

  const {
    isAdmin,
    isCompany,
    isFarm,
    isCompleteFirstFarm
  } = useSelector(selectUser)
  const currentContext = useSelector(selectCurrentContext)
  const inFarmContext = useSelector(selectInFarmContext)
  const currentProperty = useSelector(selectCurrentProperty)
  const accessType = useSelector(selectAccessType)

  const RouterContext = authenticated ? AuthenticatedScreenRouter : GuestScreenRouter

  if (
    (!isAdmin && (
      (isCompany && !inFarmContext && currentContext === AVAILABLE_CONTEXTS.farm) ||
      (isFarm && authenticated && !inFarmContext && (
        !isCompleteFirstFarm || isNil(currentProperty)
      ))
    )) || accessType?.status === 'inactive'
  ) {
    return <SelectPropertiesScreen accessType={ accessType } />
  }

  return (
    <Router forceRefresh={ forceRefresh }>
      <Suspense fallback={ <CircularLoader fullSpace /> }>
        <RouterContext />
      </Suspense>
    </Router>
  )
}

export default memo(ScreenRouter)
